import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormatPipe } from './date-format/date-format.pipe';
import { FormatoNumericoPipe } from './formato-numerico/formato-numerico.pipe';
import { FormatLinkPipe } from './imagen/format-link.pipe';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';



@NgModule({
  declarations: [
    DateFormatPipe,
    FormatoNumericoPipe,
    FormatLinkPipe,
    SafeHtmlPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DateFormatPipe,
    FormatoNumericoPipe,
    FormatLinkPipe,
    SafeHtmlPipe
  ]
})
export class PipesModule { }
